import React, { useState, useEffect, type ImgHTMLAttributes } from "react";
import { preload } from "react-dom";
import styles from "./PreloadedImage.module.scss";
import clsx from "clsx";

interface PreloadedImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  placeholderColor?: string;
  customPlaceholderClass?: string;
  customContainerClass?: string;
  aspectRatio?: string;
}

const PreloadedImage: React.FC<PreloadedImageProps> = ({
  src,
  alt,
  className,
  aspectRatio = "auto",
  placeholderColor,
  customPlaceholderClass,
  customContainerClass,
  loading = "eager",
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (src) {
      preload(src, { as: "image" });
      const img = new Image();
      img.src = src;
      img.onload = () => setIsLoaded(true);
    } else {
      setIsLoaded(true);
    }
  }, [src]);

  return (
    <div className={clsx(styles.container,customContainerClass)}>
      <div
        className={clsx(
          styles.placeholder,
          isLoaded && styles.placeholderLoaded,
          customPlaceholderClass
        )}
        style={{ backgroundColor: placeholderColor }}
      />
      <img
        src={src}
        alt={alt}
        className={clsx(
          styles.image,
          isLoaded && styles.imageLoaded,
          className
        )}
        style={{ aspectRatio }}
        loading={loading}
        {...props}
      />
    </div>
  );
};

export default PreloadedImage;
